import DiscoverSection from './DiscoverSection';

export default DiscoverSection;
